import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/common.css'; // global css
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import router from '@/router/index.js'
import keycloak from '@/utils/keycloak.js'
import { syncKeycloakToken,updateToken,setupAutoRefresh } from '@/utils/auth'


Vue.use(ElementUI);
Vue.use(VXETable);
Vue.config.productionTip = false


// ================================
// 1️⃣ 判断是否 API / token 模式
// ================================
const fullUrl = window.location.href;
const isTokenLoginMode = fullUrl.includes('/#/login?token=');
const loginOrigin = localStorage.getItem('loginOrigin')||null;

// ================================
// 2️⃣ API / token 模式（不走 Keycloak）
// ================================
function bootstrapWithoutKeycloak() {

  console.log('免密登录进入 token 模式，不初始化 Keycloak');
  localStorage.setItem('loginOrigin', 'token');
  // 👉 如果 URL 上有 token，就存
  const match = fullUrl.match(/token=([^&]+)/);
  if (match) {
    const token = match[1];
    localStorage.setItem('token', token);
  }

  new Vue({
    render: h => h(App),
    router,
  }).$mount('#app');
}



// ================================
// 3️⃣ Keycloak 模式
// ================================
function bootstrapWithKeycloak() {
  localStorage.setItem('loginOrigin', 'keycloak');
  keycloak.init({
    // onLoad: 'check-sso',
    onLoad: 'login-required',
    checkLoginIframe: false,
    pkceMethod: 'S256',
    silentCheckSsoRedirectUri:window.location.origin + '/iframe/silent-check-sso.html',
    enableLogging: true, // 开启详细日志
    // flow:'implicit',
    flow:"standard",
  }).then(authenticated => {

    if (authenticated) {
      // 如果已登录，保存 token
      syncKeycloakToken();
      const now = Math.floor(Date.now() / 1000)
      const remain = keycloak.tokenParsed.exp - now
      console.log("token剩余有效期:", remain)
      // token过期前，定时刷新token
      setupAutoRefresh()
      // token过期时，刷新token
      keycloak.onTokenExpired = function () {
        updateToken()
        console.log('token刷新成功');
      }
    }

    new Vue({
      render: h => h(App),
      router,
    }).$mount('#app')

  }).catch(err => {
    console.error('Keycloak 初始化失败', err);
  })
}

// ================================
// 4️⃣ 启动分流
// ================================
if (isTokenLoginMode||loginOrigin==='token') {
  bootstrapWithoutKeycloak();
} else {
  bootstrapWithKeycloak();
}
